import axios from 'axios'
import { casLoginUrl, heimdallUrl, endPoints } from './endpoints'

const axiosConfig = (store) => {
  axios.defaults.headers = {
    ...axios.defaults.headers,
    'x-api': 'admin_v1',
    Pragma: 'no-cache'
  }

  store.subscribe(() => {
    const {
      routing: {
        location: { pathname }
      },
      user: { clientId }
    } = store.getState()

    // set the default base url for all axios requests
    axios.defaults.baseURL = `${endPoints.clients}/${clientId}`
    axios.defaults.withCredentials = true

    //add 401 handler and redirect to CAS login
    axios.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response.status === 401) {
          window.location.replace(`${casLoginUrl}${heimdallUrl}${pathname}`)
        }
        return Promise.reject(error)
      }
    )
  })
}

export default axiosConfig



// WEBPACK FOOTER //
// ./src/config/axios.js